'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth-context';
import { cn } from '@/lib/utils';

type GoogleButtonProps = {
  onClick?: () => void;
  className?: string;
  text?: 'sign-in' | 'sign-up' | 'continue';
  callbackUrl?: string;
  action?: string;
  ref?: string;
  disabled?: boolean;
};

export const GoogleButton = ({
  onClick,
  className,
  text = 'sign-in',
  callbackUrl,
  action,
  ref,
  disabled = false,
}: GoogleButtonProps) => {
  const router = useRouter();
  const { getGoogleAuthUrl } = useAuth();

  const handleClick = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
    } else {
      router.push(getGoogleAuthUrl({ callbackUrl, action, ref }));
    }
  };

  const buttonText = () => {
    switch (text) {
      case 'sign-in':
        return 'Sign in with Google';
      case 'sign-up':
        return 'Sign up with Google';
      case 'continue':
        return 'Continue with Google';
      default:
        return 'Sign in with Google';
    }
  };

  return (
    <Button
      onClick={handleClick}
      type='button'
      disabled={disabled}
      variant='outline'
      className={cn(
        'flex h-[40px] w-full gap-2.5 rounded-md border border-[#747775] bg-white px-3 py-3 font-roboto font-medium leading-5 text-[#1F1F1F] transition-colors duration-200 hover:bg-[#F5F5F5]',
        className,
      )}
    >
      <Image src='/logos/icon-gg.svg' alt='Google' width={20} height={20} />
      {buttonText()}
    </Button>
  );
};
